/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import TeamPhoto from '../assets/images/LandingPage/teamphoto.png';
import Image from 'next/image';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "Accessibility in Curipod",
  subTitle: "",
  image: TeamPhoto,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
        children: "As an edtech company, it is critically important for us to prioritize accessibility in our products and services. Ensuring that everyone, regardless of their abilities, can access and benefit from our offerings is something we care deeply about, and strive towards in all our product development."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
        children: "One way to ensure accessibility is by following the Web Content Accessibility Guidelines (WCAG) published by the World Wide Web Consortium (W3C). WCAG provides a set of guidelines and success criteria for making web content more accessible to people with disabilities. By adhering to these guidelines, we can ensure that our products and services are accessible to as many people as possible."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
        children: "Another important tool to ensure accessibility is the Voluntary Product Accessibility Template (VPAT), which is a document that describes how our products and services conform to accessibility standards."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
        children: "Overall, prioritizing accessibility through the use of tools like WCAG and VPAT helps us create a more inclusive learning environment."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
        children: ["You can find our VPAT here: ", _jsx("a", {
          href: "/curipod_accessibility_report.pdf",
          target: "__blank",
          rel: "noopener noreferrer",
          children: "Report"
        }), "."]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
